import React from 'react'
import { Pages } from '../Pages'
import { MenuItems } from '../enums/MenuItems'
import Button from '../components/Button'
import LayoutSingleView from '../components/layout/LayoutSingleView'

function AccessDenied(): React.JSX.Element {
    return (
        <LayoutSingleView activeMenuItem={MenuItems.Roles}>
            <div className="flex justify-center mt-24">
                <div className="text-center">
                    <img src="access_denied.svg" className="w-1/2 mx-auto" />
                    <p className="mt-4 text-gray-700 text-xl">
                        You do not have permissions to access this page.
                    </p>
                    <Button
                        style="primary"
                        type="link"
                        to={Pages.Roles}
                        classes="mt-4"
                    >
                        View Roles
                    </Button>
                </div>
            </div>
        </LayoutSingleView>
    )
}

export default AccessDenied
